let i = 1;

export const generateLocalId = (prefix) => {
  const localId = `${prefix}${i}`;
  i += 1;

  return localId;
};
